import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/pencil.svg";
var PencilOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  PencilOutline_default as default
};
